import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

const intendedUses = Object.freeze([
  {
    id: '0',
    value: "Nessuna destinazione d'uso",
  },
  {
    id: '1',
    value: 'Destinato a PA estera',
  },
  {
    id: '2',
    value: `per l'uso "certificato rilasciato per procedimenti disciplinati dalle norme sull'immigrazione"`,
  },
  {
    id: '3',
    value: `per l'uso "ai sensi dell’art. 40, d.p.r. 445/2000 il presente certificato è rilasciato per cause giudiziarie"`,
  },
  {
    id: '4',
    value: `per l'uso "ai sensi dell’art. 40, d.p.r. 28 dicembre 2000, n. 445, il presente certificato è rilasciato solo per l'estero"`,
  },
]);

interface IntendedUseProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const IntendedUseListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: IntendedUseProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="intended-use-label">
        Destinazioni d&apos;uso specifica
      </InputLabel>
      <PmiSelect
        labelId="intended-use-label"
        id="intended-use"
        name="intended-use"
        value={value}
        label="Destinazioni d'uso specifica"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {intendedUses.map((intendedUse: ItemVM) => (
          <MenuItem key={intendedUse.id} value={intendedUse.id}>
            {intendedUse.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

IntendedUseListComponent.displayName = 'List intended use anpr component';

const IntendedUseList = memo(IntendedUseListComponent);

export default IntendedUseList as typeof IntendedUseListComponent;
